// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.df91ac {
  display: flex;
  align-items: center;
  gap: 40px;
  height: 48px;
  padding: 16px;
  justify-content: space-between;
  white-space: nowrap;
  cursor: pointer;
}
.b0a879 {
  background-color: var(--base-background-selected);
}
.ae54cb {
  background-color: var(--base-background-selected);
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/DropDown/components/BaseDropDownItem/BaseDropDownItem.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iDAAiD;AACnD;AACA;EACE,iDAAiD;AACnD","sourcesContent":[".df91ac {\n  display: flex;\n  align-items: center;\n  gap: 40px;\n  height: 48px;\n  padding: 16px;\n  justify-content: space-between;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.b0a879 {\n  background-color: var(--base-background-selected);\n}\n.ae54cb {\n  background-color: var(--base-background-selected);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
